import { GOOGLE_API_KEY } from "../../../utils/constant";
import React, { useState } from "react";
import {  GoogleMap, LoadScript, Marker, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import useGeocoding from "../hook/useGeoCoding";

import GoogleAutocomplete from "react-google-autocomplete";

// import "react-places-autocomplete/dist/styles.css";

const MapContainer = ({ onLocationSelect, locationByAutoselect }) => {
  const DEFAULT_CENTER = {
    lat: 26.224523295446502,
    lng: 78.19473277648181,
  };
  console.log('onLocationSelectnew',locationByAutoselect.mark)
  const initialMarkerPosition =
  locationByAutoselect.mark && Object.keys(locationByAutoselect.mark).length
    ? locationByAutoselect.mark
    : DEFAULT_CENTER || DEFAULT_CENTER;// console.log('selectedLocatison',locationByAutoselect)
  const [selectedMarker, setSelectedMarker] = useState(locationByAutoselect.mark && Object.keys(locationByAutoselect.mark).length
  ? locationByAutoselect.mark
  : DEFAULT_CENTER || DEFAULT_CENTER);

  const { address, error, performReverseGeocoding } = useGeocoding();

  const mapStyles = {
    height: "500px",
    width: "100%",
  };
  // const { address, error } = useGeocoding();
  console.log('address',address)
  // const handleMapClick = async (event) => {
  //   const lat = event.latLng.lat();
  //   const lng = event.latLng.lng();
  //   const location = { lat, lng };

  //   // Set the selected marker
  //   console.log('inmaoLocation',location)
  //   setSelectedMarker(location);

  //   // Perform reverse geocoding to get the full address
  //   const result = await performReverseGeocoding(lat, lng);
    
  //   if (result.address) {
  //     console.log("Full Address:", result.address);
  //   } else {
  //     console.error("Error in reverse geocoding:", result.error);
  //   }
  //   // Trigger the callback
  //   onLocationSelect(location);
  // };
   const handleMapClick = async (event) => {
    console.log('event.latLng.lat()',event.latLng.lat())
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const location = { lat, lng };

    // Set the selected marker
    setSelectedMarker(location);
console.log('locatiosn',location)
    // Perform reverse geocoding to get the full address
    const result = await performReverseGeocoding(lat, lng);

    if (result.address) {
      console.log("result Address:", result);
      console.log("Full Address:", result.address);
    } else {
      console.error("Error in reverse geocoding:", result.error);
    }

    // Trigger the callback with the selected location
    onLocationSelect(location,result.address);
  };
 
  function getAddressComponent(place, type) {
    return place.address_components.find((component) => component.types.includes(type))?.long_name || "";
  }
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries: ['geometry', 'drawing'],
  });
  return (
    <>
    {/* <LoadScript googleMapsApiKey={GOOGLE_API_KEY}
    onLoad={(script) => {
      console.log("Google Maps API script loaded successfully:", script);
    }}
    onError={(error) => {
      console.error("Error loading Google Maps API script:", error);
    }}> */}
   {isLoaded &&    selectedMarker && (

        <GoogleMap
          mapContainerStyle={mapStyles}
          zoom={13}
          center={initialMarkerPosition}
          onClick={handleMapClick}
          googleMapsApiKey={GOOGLE_API_KEY}
        >
          <MarkerF position={selectedMarker} />

        </GoogleMap>
      )}
    {/* </LoadScript> */}
    </>
  );
};

const LocationSelector = ({selectedLocation, getLocationandMarkFromMa}) => {
  console.log('addressmas',selectedLocation)
  // console.log('locations',location)
  const handleLocationSelect = (location,address) => {
    // Handle the selected location (e.g., update state)
    console.log("Selected Location:", location,address);
    getLocationandMarkFromMa(location,address)
  };

  return (
    <div className="rounded-2xl overflow-hidden -mx-3 -mb-5">
      {/* <MapContainer address={address} selectedLocation={} /> */}
      <MapContainer onLocationSelect={handleLocationSelect}  locationByAutoselect={selectedLocation}/>
    </div>
  );
};

export default LocationSelector;
